import React from 'react';
import CardList from './cardList';
import CardItem from './cardItem';

const Main = props => {
  const {
    listId,
    listName,
    lists,    
    items,
    handleCreateList,
    handleDeleteListButton,
    newItemsToSave,
    handleGetItemsByListId,
    handleAddNewItemToSave,
    handleEditButton,
    handleDeleteButton,
    handleCancel,
    handleSave,
    language,
    languageFilters,
    loadingLists,
    loadingItems
  } = props;

  return (
    <div className="card-flex">
      <CardList
        listId={listId}
        lists={lists}
        handleCreateList={handleCreateList}
        handleDeleteListButton={handleDeleteListButton}
        handleGetItemsByListId={handleGetItemsByListId}
        language={language}
        languageFilters={languageFilters}
        loading={loadingLists}
      />

      <CardItem
        listId={listId}
        listName={listName}
        items={items}
        newItemsToSave={newItemsToSave}
        handleAddNewItemToSave={handleAddNewItemToSave}
        handleEditButton={handleEditButton}
        handleDeleteButton={handleDeleteButton}
        handleCancel={handleCancel}
        handleSave={handleSave}
        languageFilters={languageFilters}
        language={language}
        loading={loadingItems}
      />
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./source/client/components/account_list/main.jsx